import React, { ReactNode } from "react"

import { makeStyles } from "@mui/styles"

interface IProps {
  children: ReactNode;
  className?: string;
  embedded?: boolean;
}

export const DefaultLayout = (props: IProps) => {

  const { children, className, embedded } = props

  const classes = makeStyles({
    container: {
      paddingLeft: embedded ? 0 : "65px",
      paddingTop: embedded ? 0 : "55px",
    }
  })()

  return (
    <div className={`${classes.container} ${className || ""} default-layout`}>{children}</div>
  )
}
